var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoProibido01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    d: "M18,35.4C8.4,35.4,0.6,27.6,0.6,18S8.4,0.6,18,0.6S35.4,8.4,35.4,18C35.4,27.6,27.6,35.4,18,35.4z M7,9.5 c-1.9,2.4-2.9,5.4-2.9,8.5c0,7.7,6.2,13.9,13.9,13.9c3.1,0,6.1-1,8.5-2.9L7,9.5z M18,4.1c-3.1,0-6.1,1-8.5,2.9L29,26.5 c1.9-2.4,2.9-5.4,2.9-8.5C31.9,10.3,25.7,4.1,18,4.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProibido01);
export default __webpack_public_path__ + "static/media/ico-proibido-01.1b98c1adbbee3278e42e51790d8cd5b5.svg";
export { ForwardRef as ReactComponent };